import React, {useEffect, useState} from "react"
import {useDispatch} from "react-redux"
import {useAuth0} from "@auth0/auth0-react"
import {CSVLink} from "react-csv"
import {get} from "helpers/api"

const Export = ({history}) => {
	console.log("export data")
	const dispatch = useDispatch()
	const [token, setToken] = useState(null)
	const {getAccessTokenSilently} = useAuth0()
	const csvLinkEl = React.createRef()
	const [data, setData] = useState({})

	useEffect(() => {
		async function getToken() {
			const token = await getAccessTokenSilently()
			setToken(token)
		}

		getToken()
	}, [])

	useEffect(() => {
		if (token) {
			get(`spss-data-export`, null, {
				Authorization: `Bearer ${token}`
			}).then(d => {
				console.log(typeof d)
				setData(d)
			})
		}
	}, [token])

	const downloadReport = async () => {
		setTimeout(() => {
			csvLinkEl.current.link.click()
		})
	}

	const csvreport = {
		data: data.data,
		headers: data.headers,
		filename: "spss_export_data.csv"
	}

	return (
		<div>
			{data?.headers ? (
				<>
					<input type='button' value='SPSS EXPORT DATA' onClick={downloadReport} />{" "}
					<CSVLink headers={data.headers} filename='spss_export_data.csv' data={data.data} ref={csvLinkEl} />{" "}
				</>
			) : (
				""
			)}
		</div>
	)
}

export default Export
